import gql from 'graphql-tag'

const getBookings = () => gql`
  {
    bookings {
      bookingNumber
      startDate
      endDate
      leadPassenger
      leadPassengerLastName
      bookingSystem
      departureDate
      hasFlights
      products {
        productId
        productType
        name
        startDate
        endDate
        image
        country
        siteUrl
        classification {
          name
        }
        concept {
          name
          slug
        }
      }
    }
    historicBookings {
      bookingNumber
      startDate
      endDate
      leadPassenger
      products {
        productId
        productType
        name
        startDate
        endDate
        image
        country
        siteUrl
        classification {
          name
        }
        concept {
          name
          slug
        }
      }
    }
  }
`

const getBooking = () => gql`
  query Booking($bookingNumber: String!, $disableCache: Boolean = false) {
    booking(bookingNumber: $bookingNumber, disableCache: $disableCache) {
      bookingNumber
      startDate
      endDate
      bookingSystem
      packageType
      isCancelled
      departureDate
      hasFlights
      hasThirdPartyFlights
      products {
        adHoc
        productId
        productType
        name
        startDate
        endDate
        image
        country
        countryId
        siteUrl
        cancellationRules {
          from
          to
          currency
          amount
        }
        coordinates {
          latitude
          longitude
        }
        classification {
          name
        }
        concept {
          name
          slug
        }
        images {
          url
        }
        rooms {
          passengers
          categoryName
        }
        hotelContact {
          address {
            city
            region
            street
            postalCode
          }
          email
          phoneNumber
        }
        externalBookingReference
        destinationCode
      }
      connectedUsers {
        index
        type
        firstName
        lastName
        leadPassenger
        invitationExist
        invitationEmail
        invitationAccepted
      }
      priceInfo {
        remainingAmount
        totalPrice
        totalPriceDueDate
      }
      guideOnline {
        open
        messages {
          delivered
          fromTui
        }
      }
      agentCode
    }
    partners {
      partnerId
      memberId
    }
  }
`

const getRecommendations = () => gql`
  {
    hotelRecommendations {
      id
      name
      image
      country
      destination
      resort
      usp
      siteUrl
      isFavourite
      customerRating {
        name
        score
      }
      classification {
        name
      }
      concept {
        name
        slug
      }
    }
  }
`

const getFavouriteHotel = (hotelId) => gql`
{
  favouriteHotel (hotelId: "${hotelId}") {
    id
    isFavourite
    collections
  }  
}`

const getSelfService = (bookingNumber) => gql`
{
  selfService (bookingNumber: "${bookingNumber}") {
    isAvailable
	options {
		id
	    title
		description
	}
	cases {
		created
		message
		type
		status
	}
  }  
}`

const getGuideOnlineMessages = (bookingNumber) => gql`
{
  booking (bookingNumber: "${bookingNumber}") {
    guideOnline {
      messages {
        text
        timestamp
        fromTui
        delivered
      }
    }
  }
}`

const getAtiStatus = (bookingNumber) => gql`
{
    atiStatus (bookingNumber: "${bookingNumber}") {
        ShouldBeFilledIn
    }
}
`

const getAtiFilledIn = (bookingNumber) => gql`
{
    atiFilledIn (bookingNumber: "${bookingNumber}") {
        atiRequired
        atiFilledIn
    }
}
`

export { getBookings, getBooking, getRecommendations, getFavouriteHotel, getSelfService, getAtiStatus, getAtiFilledIn, getGuideOnlineMessages }
